"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Row_1 = __importDefault(require("./Row"));
var DEFAULT_FAQ_SIZE = 5;
var List = function (props) {
    var _a = react_1.default.useState(false), isOpen = _a[0], setIsOpen = _a[1];
    var faqs = props.faqs.slice(0, isOpen ? props.faqs.length : DEFAULT_FAQ_SIZE);
    return (react_1.default.createElement("div", { className: "coCategoryFaqList-Container" },
        react_1.default.createElement("ul", null, faqs.map(function (faq, index) { return react_1.default.createElement(Row_1.default, { key: index, faq: faq, index: index + 1 }); })),
        react_1.default.createElement("div", { className: "coCategoryFaqList-Bottom" }, props.faqs.length > DEFAULT_FAQ_SIZE && !isOpen && (react_1.default.createElement("div", { className: "coCategoryFaqList-OpenButton", onClick: function () { return setIsOpen(true); } },
            react_1.default.createElement("i", { className: "fa fa-chevron-down coCategoryFaqList-OpenButton_Icon" }),
            react_1.default.createElement("span", null, "\u305D\u306E\u4ED6\u306E\u3088\u304F\u3042\u308B\u8CEA\u554F\u3092\u898B\u308B"))))));
};
exports.default = List;
